import Nullstack from 'nullstack';
export default function IconCircleKey({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-circle-key",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "14",
    cy: "10",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
  }), "   ", Nullstack.element("path", {
    d: "M12.5 11.5l-4 4l1.5 1.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 15l-1.5 -1.5"
  }), " ");
}